// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"520875c9","239":"26c99017","453":"96453769","732":"9f115304"}[chunkId] + ".chunk.js";
};